<div class="container-up">
  <div class="container-down">
    <div class="d-inline-flex flex-column h-100 page-movements-container">
      <div class="search-filter-container">
        <div class="search-bar">
          <mat-form-field appearance="outline" class="input-search">
            <mat-label>{{ 'pages.movements_list.search' | translate }}</mat-label>
            <input [formControl]="search" autocomplete="off" matInput spellcheck="false"
              (keyup)="handleKeyUp($event)" />
            <mat-hint>
              {{ 'pages.movements_list.search_by_name' | translate }}
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="buttons-container-filter">
          <button mat-stroked-button class="filter-toggle-button" color="primary" (click)="toggleFilter()">
            <img src="../../../assets/icons/filter-icon-white.svg" alt="filter-icon" width="20px" height="20px" />
          </button>
          <button mat-stroked-button class="refresh-button" color="accent" (click)="handleClick()">
            <mat-icon class="m-0" style="color: #585858"> refresh </mat-icon>
          </button>
        </div>
      </div>


      <!-- Banner informativo de rango por defecto -->
      <div class="banner banner-info" *ngIf="showDefaultRangeBanner">
        <mat-icon class="banner-icon">info</mat-icon>
        <span>Mostrando movimientos de los últimos 31 días. Si desea buscar otro rango de fecha, utilice los filtros
          disponibles.</span>
      </div>

      <app-movements-filter [branchesValuesForSelect]="branchFilter" [userResponsible]="userResponsible"
        [cashiersValuesForSelect]="cashierFilter" [methodsValuesForSelect]="paymentMethodCollection"
        [statesValuesForSelect]="stateList" [showBranchesAndCashiers]="userResponsible || commerceUser"
        [refreshDates]="refreshDates" [showOptions]="showOptions" [isLoadingExcel]="loadingExcel"
        (filterEmitter)="handleFilterMovementsEvent($event)" (getStatesSelectValuesEmitter)="setStateList($event)"
        (getCashiersSelectValuesEmitter)="buildCashierSelect($event)" (cleanFilterEmitter)="cleanFilters($event)"
        (refreshListEmitter)="handleClick()" (downloadExcelEmitter)="excelExport($event)"
        (dateRangeChangedEmitter)="handleDateRangeChanged($event)">
      </app-movements-filter>

      <div class="actions-buttons-container">
        <button class="cierre-lote-button responsive-2 m-0" [class.fullwith]="isClover" mat-stroked-button
          color="primary" (click)="openCierreLotePopup()" [style.margin-right.px]="userResponsible ? 0 : 10">
          Resumen de operaciones diarias
        </button>
        <button class="cierre-lote-button responsive m-0" mat-stroked-button color="primary"
          (click)="openDescargarLiquidacionPopup()">
          Descargar Liquidación
        </button>
      </div>

      <div *ngIf="noMovements">
        <span>{{ 'pages.movements_list.no_movements' | translate }}</span>
      </div>

      <!-- Leyenda de rango de fechas -->
      <div class="movements-legend" *ngIf="!loading && totalSize > 0">
        <h3 *ngIf="isDefaultDateRange">{{ 'pages.movements_list.recent_movs' | translate }}</h3>
        <h3 *ngIf="!isDefaultDateRange && dateRangeText">Movimientos del {{ dateRangeText }}</h3>
      </div>

      <div class="movement-card-container" *ngIf="!loading && totalSize > 0">
        <div class="card-item" *ngFor="
            let element of filterMovs | paginate : { itemsPerPage: 10, currentPage: currentPage, totalItems: totalSize }
          ">
          <div class="movement-card">
            <div style="width: 100%" (click)="viewDetail(element)">
              <div class="movement-card-first-line">
                <div class="icon-title-wrapper">
                  <img alt="" [src]="getIcon(element).iconURL" width="50px" height="40px" />
                  <div class="movement-card-title">
                    <span *ngIf="!isPixType(element.mpTipo.id)" [innerHTML]="element.titulo"></span>
                    <span *ngIf="isPixType(element.mpTipo.id)" [innerHTML]="formatCPF(element.titulo)"></span>
                  </div>
                </div>
                <div class="movement-card-badge" [ngClass]="setClassEstado(element.estado)">
                  <span>{{ element.estado }}</span>
                </div>
              </div>
              <div class="movement-card-detail">
                <div class="movement-card-detail-left">
                  <span style="padding-left: 5px" *ngIf="!isPixType(element.mpTipo.id)">
                    {{ element.cuilCuitContraparte && element.cuilCuitContraparte.length > 8 ? 'CUIL/CUIT' : 'DNI ' }}:
                    {{ element.cuilCuitContraparte ? maskCuit(element.cuilCuitContraparte) : 'No especificado' }}
                  </span>
                  <span style="padding-left: 5px" *ngIf="!isPixType(element.mpTipo.id)" class="movement-card-cvu">
                    CVU/CBU : {{ element.cvuContraparte ? element.cvuContraparte : 'No especificado' }}
                  </span>
                  <span style="padding-left: 5px" *ngIf="isPixType(element.mpTipo.id)">
                    Número de operación:
                    <strong>#{{ element.id }}</strong>
                  </span>
                  <span style="padding-left: 5px" *ngIf="isPixType(element.mpTipo.id) && element.phoneClientPix">
                    Teléfono:
                    <strong>{{ formatPhone(element.phoneClientPix) }}</strong>
                  </span>
                  <span style="padding-left: 5px" *ngIf="isRechazadoMovement(element.estado)">
                    Motivo:
                    <strong>{{ element.observaciones | titlecase }}</strong>
                  </span>
                  <span style="padding-left: 5px" class="movement-card-debin" *ngIf="element.debinId?.length === 22">
                    DEBIN ID :{{ element.debinId }}
                  </span>
                </div>
                <div class="movement-card-detail-right">
                  <span class="movement-card-amount">{{ element.importe | customCurrency }}</span>
                  <span class="movement-card-amount-date">{{ element.fecha | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
                </div>
              </div>
            </div>
            <div class="print-icon-container" (click)="printTkt(element.id)"
              *ngIf="showPrintButton(element.estado, element.conceptoTipo, element.mpTipo.id)">
              <button mat-button class="button-print">
                <mat-icon class="icon-print" *ngIf="isClover">print</mat-icon>
                <mat-icon class="icon-print" *ngIf="!isClover"> download</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loading" class="loader-container">
        <img style="border-radius: 57px" src="assets/icons/logo-fiser-loading.gif" alt="" width="150px" />
      </div>
    </div>

    <pagination-controls *ngIf="!loading && filterMovs.length > 0" class="my-pagination px-4" responsive="true"
      maxSize="7" previousLabel="" nextLabel="" (pageChange)="currentPage = $event; nextPage()">
    </pagination-controls>
  </div>
</div>